import { useMutation } from '@tanstack/react-query'
import axios from 'axios'

import { toCamelCase } from '../lib/typeHelper'

export interface CarrierSearchMatch {
  dotNumber: string
  legalName: string
  dbaName: string
  city: string
  state: string
}

export interface CarrierSearchResponse {
  results: CarrierSearchMatch[]
  hasMore: boolean
}

export const MIN_CARRIER_NAME_LENGTH = 2

/** Active carriers in FMCSA's census whose name matches, for a visitor who doesn't know their DOT. */
export function searchCarriersByName(name: string): Promise<CarrierSearchResponse> {
  return axios
    .get('/api/v1/insure/insurance-application/carrier-search/', { params: { name } })
    .then((response) => toCamelCase(response.data) as CarrierSearchResponse)
}

export function useCarrierSearch() {
  return useMutation({ mutationFn: searchCarriersByName })
}
